import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'

type MeetingPlaceCardProps = {
  dataTestId?: string
  description: string
  icon: React.ReactNode
  isRecommended?: boolean
  recommendedLabel?: string
  label: string
  onSelect: () => void
  selected: boolean
}

export default function MeetingPlaceCard({
  dataTestId,
  description,
  icon,
  isRecommended = false,
  recommendedLabel = 'Recommended',
  label,
  onSelect,
  selected,
}: MeetingPlaceCardProps) {
  return (
    <Card
      variant="outlined"
      role="radio"
      aria-checked={selected}
      sx={{
        cursor: 'pointer',
        borderColor: selected ? 'primary.main' : 'divider',
        borderWidth: selected ? 2 : 1,
        bgcolor: selected ? 'primary.50' : 'background.paper',
        transition: 'border-color 150ms ease, background-color 150ms ease',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        '&:hover': {
          borderColor: 'primary.main',
          bgcolor: selected ? 'primary.50' : 'action.hover',
        },
      }}
    >
      <CardActionArea onClick={onSelect} sx={{ height: '100%' }} data-testid={dataTestId}>
        <CardContent>
          <Stack alignItems="center" spacing={1} sx={{ textAlign: 'center', py: 1 }}>
            <Stack sx={{ fontSize: 32 }}>{icon}</Stack>
            <Typography variant="subtitle2">{label}</Typography>
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
            {isRecommended && (
              <Chip label={recommendedLabel} size="small" color="primary" variant="outlined" sx={{ mt: 0.5 }} />
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
